import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import DuplicatesModal from './duplicates-modal/DuplicatesModal';
import useCommonModal from '../../../../../../hooks/useCommonModal';
import CommonIconButton from '../../../../../../components/common-icon-button/CommonIconButton';

import scss from './DuplicateSection.module.scss';

function DuplicateSection({ onClearDuplicates, onRemoveDuplicated, duplicates = [] }) {
  const { t } = useTranslation('activ8');

  const { isOpen, handleOpenModal, handleCloseModal } = useCommonModal();

  const handleCloseDuplicatesSection = () => {
    onClearDuplicates();
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.infoWrapper}>
        <Icon icon={ICONS.Info} disableCommonColors className={scss.infoIcon} />
        <span>{t('thisFileCouldBeSimilarToUploaded')}</span>
        <button type='button' className={scss.button} onClick={handleOpenModal}>
          {duplicates.length > 1
            ? t('similarFiles', { number: duplicates.length })
            : t('similarFile', { number: duplicates.length })}
        </button>
      </div>

      <CommonIconButton
        icon={ICONS.Cross}
        onClick={handleCloseDuplicatesSection}
        isStrokeIcon
        iconClassName={scss.closeIcon}
      />

      <DuplicatesModal
        isOpen={isOpen}
        onClose={handleCloseModal}
        duplicates={duplicates}
        onSkip={onRemoveDuplicated}
        onAddAnyway={handleCloseDuplicatesSection}
      />
    </div>
  );
}

export default DuplicateSection;
